'use strict';
import React from 'react';
import classNames from 'classnames';
import Dropdown from '../../inputs/dropdown/dropdown';
import DropdownMenu from '../../inputs/dropdown/dropdownMenu';

/**
 * A DropDown component can be inserted into SiteHeader-userMenu element to implement a user menu.
 * SiteHeader-userMenuIcon should include the .is-active state class when the DropDown-menu is active.
 * Children accepts DropdownMenuItem components in order to render the proper menu options.
 *
 * @extends {React.Compponent}
 * @property {String} userName Renders the current user name for the application.
 * @property {Boolean} isActive Determines if the menu will be up or not.
 */
class SiteHeaderUserMenu extends React.Component {

  getIconButtonClassNames (isActive) {
    return classNames({
      'SiteHeader-userMenuIcon': true,
      'is-active': isActive,
      'Icon': true,
      'Icon--chevronDown': true
    });
  }
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { isActive, userName, children, ...otherProps } = this.props;

    return (
      <div {...otherProps} className="SiteHeader-userMenu">
        <Dropdown>
          <button className="SiteHeader-userMenuButton">
              <span className="SiteHeader-greeting">{'Welcome, ' + userName}</span>
              <span className={this.getIconButtonClassNames(isActive)}></span>
          </button>
          <DropdownMenu isActive={isActive}>
            {children}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

SiteHeaderUserMenu.propTypes = {
  isActive: React.PropTypes.bool,
  userName: React.PropTypes.string.isRequired
};

SiteHeaderUserMenu.defaultProps = {
  isActive: false
};

export default SiteHeaderUserMenu;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteHeader/siteHeaderUserMenu.jsx